module.exports = __webpack_public_path__ + "static/media/imagem-food-pequena.64b4321b.jpg";